import { PORTRAIT_GAME_HISTORY_TABLE } from '../../constants/portraitGameHistoryTable/portrait-game-history-table.constant'

//Game history arrow icon
import * as showMoreIcon from '../../assets/fontawesome/arrow-alt-circle-down-solid.svg'

/**
 * @file Defines the {@link GameHistoryManager} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /** Class for handling what version of game history to display depending on orientation on mobile */
 export class GameHistoryManager {

    /**
     * Reference to game history replay details table node
     * @memberof GameHistoryManager
     * @protected
     * @instance
     * @type {HTMLElement}
     */
    _table

    /**
     * Initialise game history manager
     */
    constructor() {

        //If mobile
        if (framework.isTouch()) {

            let p  = document.getElementsByClassName('__content')[0] //Store reference to parent node
            let ls = p.querySelectorAll('table')[0]                  //Store reference to game history replay details table node
            ls.id  = 'landscape-bet-history-table'                   //Create ID

            //Create portrait game history replay details table
            this._table     = document.createElement('table')
            this._table.id  = 'portrait-bet-history-table'
            this._table.createTBody()

            //For each row of headings in portrait game history replay details table
            for (let r in PORTRAIT_GAME_HISTORY_TABLE.headings) {

                let row         = PORTRAIT_GAME_HISTORY_TABLE.headings[r] //Store row of headings
                let headingsRow = this._table.insertRow(-1)               //Create table row for headings

                //For each heading
                for (let i = 0; i < row.length; i++) {

                    let th       = document.createElement('th') //Create table header
                    th.innerHTML    = Translate.do(row[i].text) //Translate & add header

                    //If colspan is defined
                    if (row[i].colspan) {
                        th.colSpan = row[i].colspan //Apply colspan attribute
                    }

                    headingsRow.appendChild(th) //Add table header to headings row

                }

                let dataRow = this._table.insertRow(-1) //Create table row for data

                //For each heading
                for (let i = 0; i < row.length; i++) {
                    dataRow.insertCell(-1) //Create table data cell
                }

            }

            //NB: ChildNode.after() not supported in IE https://caniuse.com/#feat=dom-manip-convenience (12-06-2019)
            ls.after(this._table) //Add portrait game history replay details table after landscape table

        }

    }

    /**
     * Generates and outputs data into portrait game history replay details table
     * @param {object} d_ Display bet object used in iron dog framework containing bet details
     */
    data(d_) {

        const { MainMenu } = window // Destructure MainMenu object from window for helper functions

        // Format dates for localised display
        const fPlaced   = MainMenu.dateTimeWithBreak(MainMenu.formatDate(new Date(d_.when)));
        const fSettled  = MainMenu.dateTimeWithBreak(MainMenu.formatDate(new Date(d_.settled)));

        //Initialize object which maps headings to calculate correct value for data
        let data = {

            'status':    d_.status,
            'channel':   d_.channel,
            'placed':    fPlaced,
            'settled':   fSettled,
            'bet':       `${window.currencyLookup(d_.currency)}${d_.stake}${window.extraStakeValue !== undefined ? window.extraStakeValue : ''}`,
            'coins':     (framework.getSetup().getPaylines() ? framework.getSetup().getPaylines().length : framework.getSetup().getPaylinesNum()),
            'bet/lines': `${window.currencyLookup(d_.currency)}${window.betPerLine}${window.extraStakeValue !== undefined ? window.extraStakeValue : ''}`,
            'total win': `${window.currencyLookup(d_.currency)}${d_.winnings}`

        }

        let headings = [] //Initialize array to store all headings

        //For each row of headings
        for (let r in PORTRAIT_GAME_HISTORY_TABLE.headings) {

            let row  = PORTRAIT_GAME_HISTORY_TABLE.headings[r]  //Store row of headings
            headings = headings.concat(row)                     //Merge into headings array

        }

        let td = this._table.querySelectorAll('td') //Retrieve table cells

        //For each heading
        for (let i = 0; i < headings.length; i++) {

            td[i].innerHTML = data[headings[i].text.toLowerCase()] //Populate heading's corresponding table cell with data

            //If heading has colspan attribute
            if (headings[i].colspan) {
                td[i].colSpan   = headings[i].colspan   //Apply colspan to table cell
            }

        }

    }

    /**
     * Generate arrow svg to navigate between game-history pages
     * @param {string} c_ - Class to add to svg
     * @param {number} e_ - Earliest bet number to display
     * @param {number} l_ - Oldest bet number to display
     * @return {string} String representation of game-history-arrow
     */
    arrow(c_, e_, l_) {

        //Create li item
        let li = document.createElement('li')
        li.classList.add('game-history-list-arrow')

        //Add class to show more/less icon NB: due to shit IE cant use Element.classList.add() instead have to add into SVG string directly
        let icon = showMoreIcon.replace(/class="(.*?)"/g, `class="$1 ${c_}"`)

        //Add svg icon to li
        li.innerHTML = icon

        //Create span to store bet numbers to display
        let span = document.createElement('span')
        span.innerHTML = `${e_}-${l_}`

        //Add span to list
        li.appendChild(span)

        //Return string representation of li
        return li.outerHTML

    }

 }